import * as types from '../mutation-types'
export const state = {
    closePop : false,
    headerPop : false,
    locationPop : false,
    customerPop: false,
    comfirmPop: false,
    categoryPop_up: false,
    cannelPop : false,
    editPop: false,
    itemPop: false,
    footer: false
}
export const getters = {
   closePop : state => state.closePop,
   headerPop : state => state.headerPop,
   locationPop : state => state.locationPop,
   customerPop : state => state.customerPop,
   itemPop : state => state.itemPop,
   comfirmPop : state => state.comfirmPop,
   cannelPop : state => state.cannelPop,
   editPop : state => state.editPop,
   categoryPop_up : state => state.categoryPop_up,
   footer : state => state.footer
}
export const mutations = {
    [types.POPUP_CLOSE](state,payload){
        state.closePop = payload;
    },
    [types.MUTATION_FOOTER_STATUS](state,payload){
        state.footer = payload
    },
    [types.HEADER_POPUP_ACTIVE](state,payload){
        state.headerPop = payload
    },
    [types.UPDATE_POP_STATUS](state,payload){
        state.closePop = payload
    },
    [types.MUTATION_CLOSE_STATUS](state,payload){
        state.closePop = payload
    },
    [types.MUTATION_SHOW_STATUS](state,payload){
        state.showPop = payload
    },
    [types.MUTATION_ITEMS_STATUS](state,payload){
        state.itemPop = payload
    },
    [types.MUTATION_LOCATIONS_STATUS](state,payload){
        state.locationPop = payload
    },
    [types.MUTATION_CATEGORY_STATUS](state,payload){
        state.categoryPop_up = payload
    },
    [types.MUTATION_CUSTOMERS_STATUS](state,payload){
        state.customerPop =payload
    },
    [types.MUTATION_COMFIRM_POP_STATUS](state,payload){
        state.comfirmPop = payload;
    },
    [types.MUTATION_CANNEL_POP_STATUS](state,payload){
        state.cannelPop = payload;
    },
    [types.MUTATION_EDIT_ITEMS_POP_STATUS](state,payload){
        state.editPop = payload;
    }

}
export const actions = {
    closePop : function ({ commit, getters }, payload) {
        commit(types.POPUP_CLOSE, !getters.closePop) 
    },
    showPop : function ({commit,getters},payload){
        commit(types.HEADER_POPUP_ACTIVE,!getters.showPop)
    },
    updateClosePopAction :function ({commit}, payload){
        commit(types.MUTATION_CLOSE_STATUS,payload)
    },
    updateHeaderPopAction : function({commit},payload){
        commit(types.HEADER_POPUP_ACTIVE,payload)
    },
    updateFooterAction : function({commit},payload){
        commit(types.MUTATION_FOOTER_STATUS,payload)
    },
    async updateItemPopAction ({commit},payload){
        commit(types.MUTATION_ITEMS_STATUS,payload)
    },
    updateLocationPopAction: function({commit},payload){
        commit(types.MUTATION_LOCATIONS_STATUS,payload)
    },
    updateCategoryPopAction: function({commit},payload){
        commit(types.MUTATION_CATEGORY_STATUS,payload)
    },
    updateCustomerPopAction :function({commit},payload){
        commit(types.MUTATION_CUSTOMERS_STATUS,payload)
    },
    updateComfirmPopAction : function({commit},payload){
        commit(types.MUTATION_COMFIRM_POP_STATUS,payload)
    },
    updateCannelPopAction : function({commit},payload){
        commit(types.MUTATION_CANNEL_POP_STATUS,payload)
    },
    updateEditItemsPopAction : function({commit},payload){
        commit(types.MUTATION_EDIT_ITEMS_POP_STATUS,payload)
    }
}